export default __webpack_public_path__ + "static/media/settings.95f6dce0.svg";